import React, { useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import SelectedContent from "components/library/SelectedContent/SelectedContent";
import styles from "./DeepDiveStory.css";
import Label from "components/library/Label";
import TextInput from "components/library/TextInput";
import Button from "components/library/Button/Button";
import Checkbox from "components/library/Checkbox/Checkbox";
import { getSeriesContentPrefixes } from "utils/contentDisplay";

function DeepDiveStory({
  content,
  storyOrder,
  onRemove,
  numberingOverride,
  onChangePrefix,
  stories,
}) {
  const customPrefix = numberingOverride[content.id];
  const [isEditFormOpen, setIsEditFormOpen] = useState(false);
  const [prefixInputValue, setPrefixInputValue] = useState(customPrefix || "");
  const [useAutoPrefix, setUseAutoPrefix] = useState(!customPrefix);
  const generatedPrefix = getSeriesContentPrefixes(stories, {
    ...numberingOverride,
    [content.id]: prefixInputValue,
  })[storyOrder];

  const cancelForm = () => {
    setIsEditFormOpen(false);
    setPrefixInputValue(customPrefix || "");
    setUseAutoPrefix(!customPrefix);
  };

  return (
    <div className={classNames({ [styles.editForm]: isEditFormOpen })}>
      {isEditFormOpen ? (
        <Label className={styles.formLabel}>Edit Story</Label>
      ) : null}
      <SelectedContent
        content={content}
        onRemove={isEditFormOpen ? undefined : onRemove}
        contentPrefix={isEditFormOpen ? "" : generatedPrefix}
        onEdit={isEditFormOpen ? undefined : () => setIsEditFormOpen(true)}
      />
      {isEditFormOpen ? (
        <form
          onSubmit={event => {
            event.preventDefault();
            const trimmedPrefix = prefixInputValue.trim();
            setPrefixInputValue(trimmedPrefix);
            onChangePrefix(trimmedPrefix);
            setIsEditFormOpen(false);
            setUseAutoPrefix(!prefixInputValue);
          }}
        >
          <div className={styles.checkboxWrapper}>
            <Checkbox
              isChecked={useAutoPrefix}
              onChange={({ target: { checked } }) => {
                setUseAutoPrefix(checked);
                if (checked) {
                  setPrefixInputValue("");
                }
              }}
              label="Include in auto-numbering of Deep Dive stories"
              className={styles.formInput}
            />
          </div>
          <TextInput
            label="Deep Dive story prefix"
            id={content.id}
            className={styles.formInput}
            disabled={useAutoPrefix ? "disabled" : ""}
            onChange={({ target: { value } }) => setPrefixInputValue(value)}
            value={useAutoPrefix ? generatedPrefix : prefixInputValue}
            fullWidth
          />
          <Button
            type="secondary"
            htmlType="submit"
            className={styles.submitButton}
          >
            Apply changes
          </Button>
          <Button type="tertiary" htmlType="button" onClick={cancelForm}>
            Cancel
          </Button>
        </form>
      ) : null}
    </div>
  );
}

DeepDiveStory.propTypes = {
  onRemove: PropTypes.func.isRequired,
  storyOrder: PropTypes.number,
  content: PropTypes.object,
  stories: PropTypes.array,
  onChangePrefix: PropTypes.func.isRequired,
  numberingOverride: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  stories: state.deepDiveEditor.form.stories,
});

export default connect(mapStateToProps)(DeepDiveStory);
